import styled from 'styled-components';
import { Card, Tabs, Form, Input, Tag } from 'antd';

export const AccountWrapper = styled.div`
  width: 600px;
  max-width: 800px;
  margin: 2em auto;
  padding: 0 20px;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;

export const StyledCard = styled(Card)`
  margin-top: 16px;
`;

export const StyledInput = styled(Input)`
  &[disabled] {
    background-color: hsl(var(--muted));
    color: hsl(var(--muted-foreground));
    cursor: default;
  }
`;

export const StatusSection = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr;
  row-gap: 16px;

  .label {
    color: rgba(0, 0, 0, 0.45);
  }

  .value {
    display: flex;
    align-items: center;
  }
`;

export const StyledTag = styled(Tag)`
  text-transform: capitalize;
  min-width: 80px;
  text-align: center;
`;

export const StyledTabs = styled(Tabs)`
  .ant-tabs-content-holder {
    overflow: auto;
  }

  .ant-tabs-content {
    height: 100%;
  }

  .ant-tabs-tabpane {
    min-height: 0;
  }
`;

export const NotificationsForm = styled(Form)`
  .ant-form-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    width: 100%;

    .ant-form-item-row {
      width: 100%;
    }

    .ant-form-item-label {
      flex: 0 0 auto;
    }

    .ant-form-item-control {
      flex: 0 0 auto;
      margin-left: auto;
    }
  }
`;
